import { render, staticRenderFns } from "./MoleculeStatementsSlider.vue?vue&type=template&id=7b6a7205&"
import script from "./MoleculeStatementsSlider.vue?vue&type=script&lang=js&"
export * from "./MoleculeStatementsSlider.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeStatementsSlider.vue?vue&type=style&index=0&id=7b6a7205&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports